module.exports = () => {
  return {
    /** 标题名称 */
    name: {
      label: '标题名称',
      type: 'input',
      props: {
        placeholder: '请输入标题名称',
      },
      value: '',
    },
  };
};
